// Centralizado: gerencia TODOS os tokens
// Esta é a ÚNICA fonte de verdade para token no localStorage

const STORAGE_KEY_ACCESS_TOKEN = 'accessToken';
const STORAGE_KEY_REFRESH_TOKEN = 'refreshToken';
const STORAGE_KEY_USER = 'user';

export const authService = {
  // 🔐 GET - Recuperar token (sempre pelo mesmo lugar)
  getAccessToken: (): string | null => {
    const token = localStorage.getItem(STORAGE_KEY_ACCESS_TOKEN);
    console.log('🔐 [authService.getAccessToken]', {
      temToken: !!token,
      tamanho: token?.length || 0,
      primeiros30chars: token?.substring(0, 30) || 'NULO',
    });
    return token;
  },

  getRefreshToken: (): string | null => {
    const token = localStorage.getItem(STORAGE_KEY_REFRESH_TOKEN);
    console.log('🔐 [authService.getRefreshToken]', {
      temToken: !!token,
      tamanho: token?.length || 0,
    });
    return token;
  },

  getUser: () => {
    const user = localStorage.getItem(STORAGE_KEY_USER);
    console.log('👤 [authService.getUser]', {
      temUser: !!user,
      isValid: user && user !== 'undefined' && user !== 'null',
    });
    if (!user || user === 'undefined' || user === 'null') return null;
    try {
      const parsed = JSON.parse(user);
      console.log('👤 [authService.getUser] Parsed:', { id: parsed?.id, email: parsed?.email });
      return parsed;
    } catch (e) {
      console.error('👤 [authService.getUser] Erro ao parsear:', e);
      return null;
    }
  },

  isAuthenticated: (): boolean => {
    const hasToken = !!authService.getAccessToken();
    console.log('🔐 [authService.isAuthenticated]', hasToken);
    return hasToken;
  },

  // 🔓 SET - Salvar tokens (sempre pelo mesmo lugar)
  setTokens: (accessToken: string, refreshToken: string, user?: any) => {
    console.log('✅ [authService.setTokens] Salvando tokens...', {
      accessTokenTamanho: accessToken?.length || 0,
      refreshTokenTamanho: refreshToken?.length || 0,
      hasUser: !!user,
    });
    localStorage.setItem(STORAGE_KEY_ACCESS_TOKEN, accessToken);
    localStorage.setItem(STORAGE_KEY_REFRESH_TOKEN, refreshToken);
    if (user) {
      localStorage.setItem(STORAGE_KEY_USER, JSON.stringify(user));
    }

    // Verificar imediatamente se foi salvo
    const verificar = localStorage.getItem(STORAGE_KEY_ACCESS_TOKEN);
    console.log('✅ [authService.setTokens] Verificação pós-salvamento:', {
      foiSalvo: !!verificar,
      igual: verificar === accessToken,
    });
  },

  // 🗑️ CLEAR - Remover tokens (sempre pelo mesmo lugar)
  clearTokens: () => {
    console.log('🗑️ [authService.clearTokens] Limpando tokens do localStorage');
    localStorage.removeItem(STORAGE_KEY_ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEY_REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEY_USER);

    // Verificar se foi deletado
    const verificar = localStorage.getItem(STORAGE_KEY_ACCESS_TOKEN);
    console.log('🗑️ [authService.clearTokens] Verificação pós-limpeza:', {
      aindaláToken: !!verificar,
    });
  },
};
